module.exports = __webpack_public_path__ + "img/gjn-login.fc566634.svg";